export { default as CreateGlobalCompanyTabForm } from './CreateGlobalCompanyTabForm';
